import { jsxs as i, jsx as l } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as C } from "./index.es2447.js";
function H({ size: e = C }) {
  return /* @__PURE__ */ i(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l("rect", { y: "0.936646", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M16 18.7656C16 17.7555 16.8189 16.9366 17.829 16.9366H38.171C39.1811 16.9366 40 17.7555 40 18.7656V35.1077C40 36.1178 39.1811 36.9366 38.171 36.9366H17.829C16.8189 36.9366 16 36.1178 16 35.1077V18.7656Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ l("path", { d: "M34.6667 20.9366H32V32.9366H34.6667V20.9366Z", fill: "white" }),
        /* @__PURE__ */ l("path", { d: "M26.6667 24.9366H29.3334V32.9366H26.6667V24.9366Z", fill: "white" }),
        /* @__PURE__ */ l("path", { d: "M21.3333 28.9366H23.9999V32.9366H21.3333V28.9366Z", fill: "white" }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31.5 20.9366C31.5 20.6605 31.7239 20.4366 32 20.4366H34.6667C34.9428 20.4366 35.1667 20.6605 35.1667 20.9366V32.9366C35.1667 33.2128 34.9428 33.4366 34.6667 33.4366H32C31.7239 33.4366 31.5 33.2128 31.5 32.9366V20.9366ZM32.5 21.4366V32.4366H34.1667V21.4366H32.5Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M26.6667 24.4366C26.3906 24.4366 26.1667 24.6605 26.1667 24.9366V32.9366C26.1667 33.2128 26.3906 33.4366 26.6667 33.4366H29.3334C29.6096 33.4366 29.8334 33.2128 29.8334 32.9366V24.9366C29.8334 24.6605 29.6096 24.4366 29.3334 24.4366H26.6667ZM28.8334 32.4366H27.1667V25.4366H28.8334V32.4366Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.3333 28.4366C21.0571 28.4366 20.8333 28.6605 20.8333 28.9366V32.9366C20.8333 33.2128 21.0571 33.4366 21.3333 33.4366H23.9999C24.2761 33.4366 24.4999 33.2128 24.4999 32.9366V28.9366C24.4999 28.6605 24.2761 28.4366 23.9999 28.4366H21.3333ZM21.8333 32.4366V29.4366H23.4999V32.4366H21.8333Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 18.7656C16 17.7555 16.8189 16.9366 17.829 16.9366H38.171C39.1811 16.9366 40 17.7555 40 18.7656V35.1077C40 36.1178 39.1811 36.9366 38.171 36.9366H28.5V39.6033C28.5 39.6617 28.49 39.7178 28.4716 39.7699H34.6666V40.7699H21.3333V39.7699H27.5284C27.51 39.7178 27.5 39.6617 27.5 39.6033V36.9366H17.829C16.8189 36.9366 16 36.1178 16 35.1077V18.7656ZM17.829 17.9366H38.171C38.6288 17.9366 39 18.3078 39 18.7656V35.1077C39 35.5655 38.6288 35.9366 38.171 35.9366H17.829C17.3712 35.9366 17 35.5655 17 35.1077V18.7656C17 18.3078 17.3712 17.9366 17.829 17.9366Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
H.__tags = [];
export {
  H as MetricFootTrafficIcon
};
//# sourceMappingURL=index.es408.js.map
